<template>
  <v-container fluid py-0>
    <v-layout wrap row>
      <template v-if="!loading">
        <v-flex v-if="video && video.src" xs12 md6>
          <youtube-player
            v-if="video.type == 'video/youtube'"
            ref="youtubePlayer"
            :video="video"
          />

          <video-player v-else ref="videoPlayer" :video="video" />
        </v-flex>
      </template>
      <v-flex xs12 md6 :offset-md3="!video || !video.src">
        <EventList
          :items="formatedList"
          :loading="loading || loadingEvents"
          @create="setNew"
          @setEvent="setEvent"
        />
      </v-flex>
    </v-layout>

    <dialog-event
      :dialog.sync="dialog"
      :match-id="matchId"
      :training-id="trainingId"
      :home-team-id="homeTeamId"
      :visitor-team-id="visitorTeamId"
      :location="location"
    />
    <!-- <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    /> -->
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import EventList from './match-events/components/EventList'
import DialogEvent from '@/components/widgets/dialog/DialogEvent'
// import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import VideoPlayer from '@/components/widgets/video/VideoPlayer'
import YoutubePlayer from '@/components/widgets/video/YoutubePlayer'
import { socket } from '@/plugins/socket'

export default {
  components: {
    VideoPlayer,
    YoutubePlayer,
    // DialogDelete,
    DialogEvent,
    EventList,
  },
  props: {
    matchId: {
      type: String,
      default: '',
      required: false,
    },
    trainingId: {
      type: String,
      default: '',
      required: false,
    },
    homeTeamId: {
      type: String,
      default: '',
      required: false,
    },
    visitorTeamId: {
      type: String,
      default: '',
      required: false,
    },
    location: {
      type: String,
      default: '',
      required: false,
    },
    video: {
      type: Object,
      required: false,
      default: () => {},
    },
    typeView: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      localEvent: {},
      eventId: '',
      duration: 0,
      dialog: false,
      idDelete: false,
      dialogDelete: false,
      loadingEvents: false,
      socketReconnectBound: false,
    }
  },

  computed: {
    ...mapState({
      loading: (state) => state.matchEvents.loading,
      selected: (state) => state.matchEvents.selected,
    }),
    ...mapGetters({
      formatedList: 'matchEvents/formatedList',
    }),

    time() {
      return (this.localEvent.minute || 0) * 60 + (this.localEvent.second || 0)
    },
    maxMinute() {
      return 59
      // return Math.floor(this.duration / 60)
    },
    maxSecond() {
      return 59
      // if (this.localEvent.minute == this.maxMinute) { return Math.floor(this.duration % 60) } else return 59
    },
  },
  watch: {
    matchId: function handle1(val, old) {
      this.handleSockets(val, old, 'match')
    },
    trainingId: function handle2(val, old) {
      this.handleSockets(val, old, 'training')
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'matchEvents/fetchOne',
      fetchMatchEvents: 'matches/fetchEvents',
      fetchTrainingEvents: 'trainings/fetchEvents',
      setDelete: 'matchEvents/delete',
      fetchTypeEvents: 'typeEvents/fetchList',
    }),
    setEvent(event) {
      // if (this.typeView === 'form') this.setOne(event._id)
      // else if (this.typeView === 'view')
      this.setTime(event.fromVideoStart)
    },
    setTime(time) {
      if (this.$refs.videoPlayer) this.$refs.videoPlayer.setTime(time)
    },
    setNew() {
      this.loadingEvents = true
      let promise = new Promise((resolve) => resolve())
      if (this.trainingId) {
        promise = this.fetchTrainingEvents(this.trainingId)
      } else if (this.matchId) {
        promise = this.fetchMatchEvents(this.matchId)
      }
      promise
        .then(() => {
          this.dialog = true
        })
        .finally(() => {
          this.loadingEvents = false
        })
    },
    setOne(id) {
      this.fetchOne(id).then(() => {
        this.$nextTick(() => {
          this.dialog = true
        })
      })
    },
    updateTime(time) {
      this.duration = time
    },
    handleSockets(val, old, type) {
      if (val != old) {
        if (!val && old) {
          //leave after join
          this.leaveSocketRooms({ old, type })
        } else {
          if (!old && val) {
            //join after empty
            this.joinSocketRooms()
          } else {
            //change
            this.leaveSocketRooms({ old, type })
            this.joinSocketRooms()
          }
        }
      }
    },
    joinSocketRooms() {
      if (
        !socket ||
        !this.$socket ||
        !this.$socket.emit ||
        (!this.matchId && !this.trainingId)
      )
        return
      if (this.matchId)
        this.$socket.emit('join', { name: 'match', id: this.matchId })
      if (this.trainingId)
        this.$socket.emit('join', { name: 'training', id: this.trainingId })
      if (this.$socket.io && !this.socketReconnectBound) {
        this.$socket.io.on('reconnect', this.joinSocketRooms)
        this.socketReconnectBound = true
      }
      if (process.env.NODE_ENV !== 'production') {
        console.log('[TabEvents] joined sockets', {
          matchRoom: this.matchId ? `match:${this.matchId}` : null,
          trainingRoom: this.trainingId ? `training:${this.trainingId}` : null,
        })
      }
    },
    leaveSocketRooms(handleConfig) {
      if (handleConfig) {
        const { old, type } = handleConfig
        if (!socket || !this.$socket || !this.$socket.emit) return

        //handle leaving with !this.matchId && !this.trainingId (exiting a page)
        if (old && type) {
          this.$socket.emit('leave', { name: type, id: old })
          if (this.$socket.io && this.socketReconnectBound) {
            this.$socket.io.off('reconnect', this.joinSocketRooms)
            this.socketReconnectBound = false
          }
          if (process.env.NODE_ENV !== 'production') {
            console.log('[TabEvents] left sockets', {
              matchRoom: type == 'match' ? `match:${old}` : null,
              trainingRoom: type == 'training' ? `training:${old}` : null,
            })
          }
          return
        }
      }

      if (!this.matchId && !this.trainingId) return
      if (this.matchId)
        this.$socket.emit('leave', { name: 'match', id: this.matchId })
      if (this.trainingId)
        this.$socket.emit('leave', { name: 'training', id: this.trainingId })
      if (this.$socket.io && this.socketReconnectBound) {
        this.$socket.io.off('reconnect', this.joinSocketRooms)
        this.socketReconnectBound = false
      }
      if (process.env.NODE_ENV !== 'production') {
        console.log('[TabEvents] left sockets', {
          matchRoom: this.matchId ? `match:${this.matchId}` : null,
          trainingRoom: this.trainingId ? `training:${this.trainingId}` : null,
        })
      }
    },
    onRemoteVideoUpdated() {
      if (process.env.NODE_ENV !== 'production') {
        console.log('[TabEvents] remote video updated event received')
      }
      if (this.matchId)
        this.$store.dispatch('matches/getMatchVideo', this.matchId)
      if (this.trainingId)
        this.$store.dispatch('trainings/getTrainingVideo', this.trainingId)
    },
  },
  sockets: {
    connect() {
      if (process.env.NODE_ENV !== 'production') {
        console.log('[TabEvents] socket connected')
      }
      this.joinSocketRooms()
    },
    'match-files'(data) {
      if (process.env.NODE_ENV !== 'production') {
        console.log('[TabEvents] match-files received', data)
      }
      this.onRemoteVideoUpdated()
    },
    'training-files'(data) {
      if (process.env.NODE_ENV !== 'production') {
        console.log('[TabEvents] training-files received', data)
      }
      this.onRemoteVideoUpdated()
    },
  },
  mounted() {
    this.joinSocketRooms()
  },
  beforeDestroy() {
    this.leaveSocketRooms()
  },
}
</script>
